import { ClipboardList, HardHat } from 'lucide-react';

/** Field-service work order. Use for nav, job cards, search, and linked jobs. */
export const JobIcon = ClipboardList;

/** Assigned field technician / job resource. */
export const EngineerIcon = HardHat;
